import React from 'react';

function Header () {

    return (
        <header className="header">
            <h1 className="header__h1">
                <span className="header__title">Nasjonal vegdatabank </span>
                <span className="header__subtitle">Datakatalog</span>
            </h1>
        </header>
    )
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header.jsx